import {HandbookVersionLoader} from './HandbookVersionLoader';

export const handbookVersionLoader: { (token?: string): HandbookVersionLoader } = (token) =>
  new HandbookVersionLoader(token);
